var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconSoccerBall = function SvgIconSoccerBall(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M11 4.062a8 8 0 0 0-6.24 4.53l2.255.734L11 6.428zM4 12q.002-.773.141-1.505l2.256.733 1.523 4.694-1.391 1.915A7.98 7.98 0 0 1 4 12m2.142 8.105A9.96 9.96 0 0 0 12 22a9.96 9.96 0 0 0 5.897-1.923A9.99 9.99 0 0 0 22 12c0-5.523-4.477-10-10-10S2 6.477 2 12a9.99 9.99 0 0 0 4.108 8.08l.017.014zM20 12a7.98 7.98 0 0 1-2.529 5.836l-1.391-1.915 1.523-4.693 2.256-.733q.14.732.141 1.505m-.76-3.407A8 8 0 0 0 13 4.062v2.366l3.985 2.898zm-3.386 10.42-1.392-1.916H9.538l-1.392 1.915A7.96 7.96 0 0 0 12 20c1.397 0 2.71-.358 3.854-.988m-7.488-8.197 1.389 4.28h4.49l1.389-4.28L12 8.174z",
    clipRule: "evenodd"
  })));
};
export default SvgIconSoccerBall;